export default {
  gewerbe: {
    hero: {
      eyebrow: 'Business customers',
      title: 'Professional video surveillance for business requirements',
      lead: 'From the retail branch to the production hall – we plan, install and maintain camera systems that serve your business. Privacy-conscious, scalable and reliable.',
    },
    types: {
      title: 'Solutions for your business',
      lead: 'Every industry has its own requirements. We know the typical challenges and plan accordingly.',
      items: {
        '0': { title: 'Retail & shops', desc: 'Entrance, sales floor, checkout zone and warehouse – discreetly but effectively monitored. Protection against theft and vandalism.', tags: { '0': 'Indoor', '1': 'Theft protection', '2': 'Checkout zone' } },
        '1': { title: 'Offices & practices', desc: 'Reception, corridors, sensitive areas and car parks – planned with privacy in mind, with access rights and private zones.', tags: { '0': 'Indoor', '1': 'Reception', '2': 'Privacy' } },
        '2': { title: 'Warehouse & logistics', desc: 'Large-area surveillance with wide-angle and PTZ cameras. Overview of delivery zones, shelves and outdoor areas day and night.', tags: { '0': 'Indoor', '1': 'Outdoor', '2': 'Night vision' } },
        '3': { title: 'Hospitality', desc: 'Entrance, counter, kitchen access and outdoor area – robust cameras for humid and hot environments.', tags: { '0': 'Indoor', '1': 'Outdoor', '2': 'Robust' } },
        '4': { title: 'Workshops & industry', desc: 'Tougher environments require particularly robust cameras. Workshops, outdoor areas and loading zones – dust- and weather-protected.', tags: { '0': 'Indoor', '1': 'Robust', '2': 'Night vision' } },
        '5': { title: 'Multiple locations', desc: 'Central access to all cameras via a single app. User management with differentiated rights for branch managers and security officers.', tags: { '0': 'Multi-site', '1': 'Central', '2': 'App' } },
      },
    },
    features: {
      title: 'Functions for business use',
      lead: 'Commercial installations require more than just cameras. We professionally set up user rights, recording schedules and notifications.',
      items: {
        '0': { title: 'User management', desc: 'Different access rights for employees, branch managers and management. Who may see which camera?' },
        '1': { title: 'Recording & archiving', desc: 'Local recorder with redundant storage. Retention period according to operational and possibly legal requirements.' },
        '2': { title: 'Event notifications', desc: 'Push messages on movement, line crossing or defined events – depending on system and configuration.' },
        '3': { title: 'Expandability', desc: 'Is your business growing? Existing systems can usually be expanded with additional cameras and locations.' },
      },
    },
    legal: {
      eyebrow: 'Data protection & law',
      title: 'Compliant business video surveillance',
      lead: 'Additional regulations apply to commercial video surveillance – especially regarding employees, customers and public areas. We support you with the technical implementation of:',
      list: {
        '0': 'Transparency and signage at entrances',
        '1': 'Privacy masking for changing rooms and break rooms',
        '2': 'Technical implementation of access rights and user management',
        '3': 'Local storage with a defined retention period',
        '4': 'Documentation of the operational necessity',
      },
      note: 'Note: The legal admissibility of business video surveillance depends on the individual case. We advise you technically, but do not replace legal advice.',
    },
    cta: {
      title: 'Your business deserves professional security',
      lead: 'We analyse your operational processes and plan a system that protects without disrupting. Without obligation and transparently.',
      primary: 'Arrange a consultation',
      secondary: 'Discover SSG Care',
    },
  },
};